var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDepartmentLogo01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_15389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4332 35.791C51.8626 31.3597 43.4376 33.167 39.0191 39.8291C35.3255 45.3947 29.7546 46.0829 27.595 46.0829C20.5665 46.0829 15.7511 41.1827 14.324 36.1086C14.3088 36.0557 14.3011 36.0178 14.2859 35.9649C14.2706 35.9044 14.2554 35.8515 14.2401 35.791C13.683 33.6736 13.538 32.6603 13.538 30.4144C13.538 18.2849 26.0992 4.77919 44.1855 4.77919C62.2718 4.77919 73.3067 18.7538 76.0387 26.52C75.993 26.3839 75.9472 26.2477 75.9014 26.1041C70.651 10.9195 56.1133 0 39.0038 0C17.4682 0 0 17.3019 0 38.6494C0 57.7284 13.8891 74.0623 33.1506 74.0623C48.5125 74.0623 58.8453 65.5248 63.5768 53.7659C66.179 47.3306 64.3323 39.7686 58.4332 35.7985V35.791Z",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2918 27.2763C74.0177 19.6991 63.3338 4.78687 44.1944 4.78687C26.1004 4.78687 13.5469 18.2926 13.5469 30.4221C13.5469 32.668 13.6842 33.6813 14.249 35.7987C14.0124 34.8761 13.8903 33.946 13.8903 33.0385C13.8903 20.41 26.6575 11.6532 39.7758 11.6532C57.5416 11.6532 71.9343 25.9227 71.9343 43.5195C71.9343 57.3201 63.9214 69.2605 52.276 74.9925C67.2792 69.616 78.0012 55.3767 78.0012 38.6495C78.0012 34.6946 77.467 31.201 76.2842 27.2763H76.2918Z",
    fill: "#E4032E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_15389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDepartmentLogo01);
export default __webpack_public_path__ + "static/media/img-department-logo-01.60e8258dd0e53d05bb7237d5138cf88d.svg";
export { ForwardRef as ReactComponent };